module.exports = __webpack_public_path__ + "img/resultat_tesseract.e58e8aee.png";